<template>
  <div :class="[active?'active-grasimi':'']">
    <div class="row height-row" @click="active=!active" data-toggle="collapse" data-target="#polioli1">
      <div class="col-md-4 col-4 border-table">
        <span v-if="!active" class="plus">+</span>
        <span v-else class="minus">-</span>
        <span class="span-black pl-0">Polioli</span>
      </div>
      <div class="col-md-4 col-4 border-table"><span class="span-black"></span></div>
      <div class="col-md-4 col-4 border-table border-last"><span class="span-black"></span></div>

    </div>

    <div id="polioli1" class="collapse">
      <div class="row  height-row">
        <div class="col-md-4 col-4 border-table"><span class="span-blue">Inozitol</span></div>
        <div class="col-md-4 col-4 border-table"><span class="span-blue">53 mg</span></div>
        <div class="col-md-4 col-4 border-table border-last"><span class="span-blue">7.2 mg</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "polioli",
  data() {
    return {
      active: false
    }
  }
}
</script>

<style>

</style>
